<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  mounted() {
    const element = document.getElementById("app");
    if (process.env.NODE_ENV == 'development'){
      console.log(`Trabanjando en '${process.env.VUE_APP_FIREBASE_PID}' firebase`)
    }
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      element.classList.add("mobile");
      //window.scrollTo(0,document.body.scrollHeight);
      window.scrollTo(0,0);
    }
    if(navigator.userAgent.match(/SAMSUNG|Samsung|SGH-[I|N|T]|GT-[I|N]|SM-[A|N|P|T|Z]|SHV-E|SCH-[I|J|R|S]|SPH-L/i)) {
      console.log("it's Samsung");
      element.classList.add("samsung");
      //window.scrollTo(0,document.body.scrollHeight);
      window.scrollTo(0,0);
    }
    window.scrollTo(0,0);
  },
}
</script>
<style lang="scss">
@import url("assets/fonts.css");
@import url("assets/animate.min.css");
@import url('styles/global.scss');
</style>
